'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var logout = exports.logout = function logout() {
  localStorage.removeItem('authorizationData');
};

var login = exports.login = function login(params) {
  localStorage.setItem('authorizationData', JSON.stringify(params));
};

var getAuthData = exports.getAuthData = function getAuthData() {
  var authData = localStorage.getItem('authorizationData');
  return authData ? JSON.parse(authData) : null;
};

var goToLogin = exports.goToLogin = function goToLogin() {
  window.location = 'login';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Auth/authUtils.js
 ** module id = 486
 ** module chunks = 0
 **/